import { circle } from "@thi.ng/geom";

import { IRect, Point } from "../../../../../../api";

export const playhead = (point: Point, parentRect: IRect) => {
  const radius = Math.max(2, parentRect.h * 0.05);
  return circle(point, radius, { fill: "rgba(43, 212, 156, 1.0)" });
};
